import React from 'react';
import WorkspaceFileCard from './WorkspaceFileCard';
import WorkspaceCommentCard from './WorkspaceCommentCard';
import WorkspaceEventCard from './WorkspaceEventCard';

const WorkspaceFeedItem = ({ item, onPreviewFile, onWorkspaceEventReply = null, layout = 'default', onOpenReply = null, onMarkRead = null }) => {
  if (item.kind === 'workspace_event') {
    return (
      <WorkspaceEventCard
        event={item.data}
        layout={layout}
        onPreviewFile={onPreviewFile}
        onWorkspaceEventReply={onWorkspaceEventReply}
        onOpenReply={onOpenReply}
        onMarkRead={onMarkRead}
      />
    );
  }
  if (item.kind === 'file') {
    return (
      <WorkspaceFileCard
        media={item.data}
        onPreview={() => onPreviewFile?.(item.data)}
      />
    );
  }
  if (item.kind === 'comment') {
    return <WorkspaceCommentCard comment={item.data} onPreviewFile={onPreviewFile} />;
  }
  return null;
};

export default WorkspaceFeedItem;
